export const FETCH_USERNAME = "FETCH_USERNAME";
export const FETCH_USERNAME_SUCCESS = "FETCH_USERNAME_SUCCESS";
export const FETCH_USERNAME_FAIL = "FETCH_USERNAME_FAIL";
